import { render, staticRenderFns } from "./xmFooter.vue?vue&type=template&id=550c1876&scoped=true&"
import script from "./xmFooter.vue?vue&type=script&lang=js&"
export * from "./xmFooter.vue?vue&type=script&lang=js&"
import style0 from "./xmFooter.vue?vue&type=style&index=0&id=550c1876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550c1876",
  null
  
)

export default component.exports